<div class="vw-toasts">
  @for (t of toastService.toasts(); track t) {
    <div class="vw-toast" [class]="t.type">
      <span class="color-white">{{ t.text }}</span>
      <i class="fal fa-times pointer" (click)="deleteToast(t.toastId)"></i>
    </div>
  }
</div>
